import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.policies.edit', {
        url: '/:policyId/edit',
        component: 'requestCenterPoliciesEdit',
        resolve: {policy},
    })
}

/** @ngInject */
function policy($stateParams, policies) {
    return policies.find(p => p.id === $stateParams.policyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/edit/approval-policies-edit.state.js